import copy from 'copy-to-clipboard';
import React from 'react';

export default function EditCopyPasteSchedule({ onPastedData, schedule, toggleScheduleForm }) {
  return (
    <div className="editable">
      <input
        className="btn"
        style={{ width: 200 }}
        onPaste={(event) => {
          event.clipboardData.items[0].getAsString((text) => {
            console.log('Got paste:', text);
            let new_schedule;
            try {
              new_schedule = JSON.parse(text);
            } catch (e) {
              alert('Schedule data not found in the clipboard\n' + e);
              return;
            }
            try {
              if (new_schedule.schedule_type != schedule.schedule_type) {
                alert(
                  `You pasted schedule '${new_schedule.schedule_type}', but this is schedule '${schedule.schedule_type}' form`
                );
                return;
              }
              console.log('Parsed Schedule', new_schedule);
              onPastedData(new_schedule);
            } catch (e) {
              console.error('Unable to paste', e);
              alert('Unable to paste ' + e);
            }
          });
        }}
        placeholder="To paste: click here and press Ctrl+V"
        readOnly
      />{' '}
      {schedule.data && (
        <button
          className="btn btn-secondary"
          onClick={() => {
            try {
              const serialized = JSON.stringify(schedule);
              console.log('Copying', serialized);
              copy(serialized, {
                format: 'text/plain',
                onCopy: () => alert(`Schedule ${schedule.schedule_type} copied to clipboard`),
              }) || alert('Sorry, something went wrong during copying :(');
            } catch (e) {
              alert('Error while copying: ' + e);
            }
          }}
        >
          Copy
        </button>
      )}{' '}
      <button className="btn btn-primary" onClick={toggleScheduleForm}>
        Edit
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/common/EditCopyPasteSchedule.jsx